import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RemoveFromRoleDocument } from './remove.generated';

export const useRemoveFromRole = (options: ApiOptions<typeof RemoveFromRoleDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(RemoveFromRoleDocument, {
    refetchQueries: [
      'RoleContentFolderList',
      'RoleDataSourceList',
      'RoleDesignFolderList',
      'RoleDeviceList',
      'RoleEventTypeList',
      'RolePlaylistFolderList',
      'RoleShowFolderList',
      'RoleUserList',
    ],
    ...useNotifications(RemoveFromRoleDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.roles.update_success'),
    }),
    ...options,
  });
};
